<template>
  <div v-if="!loading">
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="6" class="text-right">
            هنرجو:
            {{ student.name }}
          </v-col>
          <v-col cols="6" class="text-left">
            <v-icon class="back-link-icon" x-large
                    @click="$router.push('/classes/manage/index/'+onlineClassId+'/'+studentId)">
              mdi-arrow-left
            </v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>
        <v-row>
          <v-col>
            مدیریت درس {{ lesson.title }}
          </v-col>
          <v-col cols="3" style="white-space: nowrap!important">
            <v-icon color="error" large @click="lesson.score = 0">mdi-window-close</v-icon>
            <v-rating
                style="display: inline-block"
                v-model="lesson.score"
                length="5"
                background-color="orange lighten-3"
                color="orange"
                large
            >
            </v-rating>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="9">
            <v-row class="file-container">
              <v-col cols="4" class="pa-4" v-for="lessonFile in lessonFiles" :key="lessonFile.id">
                <v-row>
                  <v-col cols="12" class="single-file-container">
                    <v-row>
                      <v-col cols="12" @click="openLessonFile(lessonFile)">
                        <div class="file-show-container" v-if="selectedLessonFileForShow.id === lessonFile.id">
                          <img v-if="selectedLessonFileForShow.mime_type === 'image'"
                               :src="selectedLessonFileForShow.file" class="image-lesson"
                               :alt="selectedLessonFileForShow.title">
                          <audio v-else-if="selectedLessonFileForShow.mime_type === 'audio'"
                                 :src="selectedLessonFileForShow.file" controls style="width: 100%"></audio>
                          <video-player :options="videoOptions" source="onlineClassItem"
                                        v-else-if="selectedLessonFileForShow.mime_type === 'video'">

                          </video-player>
                          <v-btn v-else style="letter-spacing: normal" width="100%"
                                 color="primary"
                                 @click="goTo(selectedLessonFileForShow.file)">مشاهده
                          </v-btn>
                        </div>
                        <img v-else :src="lessonFile.cover_file" :alt="lessonFile.title" class="image-lesson"/>
                      </v-col>
                      <v-col cols="6">
                        {{ lessonFile.title }} |
                        <v-icon v-if="lessonFile.mime_type === 'video'">mdi-video</v-icon>
                        <v-icon v-if="lessonFile.mime_type === 'image'">mdi-image</v-icon>
                        <v-icon v-if="lessonFile.mime_type === 'audio'">mdi-music</v-icon>
                        <v-icon v-if="lessonFile.mime_type === 'text'">mdi-text</v-icon>
                        <v-icon v-if="lessonFile.mime_type === 'pdf'">mdi-file-pdf-box</v-icon>
                        <v-icon v-if="lessonFile.mime_type === 'other'">mdi-file-alert-outline</v-icon>
                      </v-col>
                      <v-col class="text-left">
                        <v-switch
                            class="ma-0 pa-0"
                            @change="changeShowStatusLessonFile(lessonFile.id,lessonFile.visibility)"
                            v-model="lessonFile.visibility"
                            color="success"
                            label="وضعیت نمایش"
                            :false-value="0"
                            :true-value="1"
                        ></v-switch>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="4" class="pa-4" v-for="dictation in dictations" :key="dictation.id + 'dictation'">
                <v-row>
                  <v-col cols="12" class="single-file-container">
                    <v-row>
                      <v-col cols="12" @click="openDictationFile(dictation)">
                        <img :src="dictation.cover_file" :alt="dictation.title" class="image-lesson"/>
                      </v-col>
                      <v-col cols="6">
                        {{ dictation.title }} |
                        <v-icon>mdi-pen</v-icon>
                      </v-col>
                      <v-col class="text-left">
                        <v-switch
                            class="ma-0 pa-0"
                            @change="changeShowStatusDictation(dictation.id,dictation.visibility)"
                            v-model="dictation.visibility"
                            color="success"
                            label="وضعیت نمایش"
                            :false-value="0"
                            :true-value="1"
                        ></v-switch>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <lesson-chat :online-class-id="onlineClassId" :lesson-id="lesson.id"
                             :student-id="studentId"
                ></lesson-chat>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="3">
            <lesson-assignment :online-class-id="onlineClassId" :lesson-id="lesson.id"
                               :student-id="studentId">
            </lesson-assignment>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import LessonChat from "@/components/OnlineClassManagement/LessonChat";
import LessonAssignment from "@/components/OnlineClassManagement/LessonAssignment";
import VideoPlayer from "@/components/Player/VideoPlayer";

export default {
  name: "OnlineClassItem",
  components: {VideoPlayer, LessonAssignment, LessonChat},
  data() {
    return {
      loading: true,
      itemId: null,
      studentId: null,
      student: null,
      onlineClassId: null,
      lesson: null,
      lessonFiles: [],
      dictations: [],
      showStatusOfLessonFiles: [],
      selectedLessonFileForShow: {
        id: null
      },
      selectedDictationForShow: {
        id: null
      },
      videoOptions: {
        autoplay: true,
        playbackRates: [0.5, 1, 1.5, 2, 4, 8],
        controls: true,
        liveui: true,
        responsive: true,
        sources: [
          {
            src: '',
            type: "application/vnd.apple.mpegurl"
          }
        ],
      },
    }
  },
  watch: {
    'lesson.score'(value) {
      if (value !== null) {
        this.setScore(value)
      }
    }
  },
  mounted() {
    this.itemId = this.$route.params.itemId
    this.studentId = this.$route.params.studentId
    this.onlineClassId = this.$route.params.classId
    this.getLesson()
    this.getStudentDetails()
  },
  methods: {
    getStudentDetails() {
      window.axios.get('/admin/student/get/' + this.studentId).then((res) => {
        this.student = res.data.data
        console.log(this.student)
      })
    },
    goTo(path) {
      window.open(path)
    },
    openLessonFile(lessonFile) {
      if (lessonFile.mime_type === 'video') {
        this.videoOptions.sources[0].src = lessonFile.file
      }
      this.selectedLessonFileForShow = lessonFile
    },
    openDictationFile(dictation) {
      this.$router.push(`/classes/manage/dictation/show/${this.onlineClassId}/${this.itemId}/${dictation.id}/${this.studentId}`)
    },
    getLesson() {
      window.axios.get('/class/manage/student/lesson/' + this.studentId + '/' + this.onlineClassId + '/' + this.itemId).then((res) => {
        this.lesson = res.data.data.item
        this.lessonFiles = res.data.data.files
        this.dictations = res.data.data.dictations
        this.loading = false
      })
    },
    changeShowStatusLessonFile(itemFileId, value) {
      window.axios.get('/class/manage/lesson/file/visibility/' + this.studentId + '/' + this.onlineClassId + '/' + this.itemId + '/' + itemFileId + '/' + value).then(() => {
        this.getLesson()
      })
    },
    changeShowStatusDictation(itemDictationId, value) {
      //add this route
      window.axios.get('/class/manage/dictation/file/visibility/' + this.studentId + '/' + this.onlineClassId + '/' + this.itemId + '/' + itemDictationId + '/' + value).then(() => {
        this.getLesson()
      })
    },
    setScore(score) {
      window.axios.get('/class/manage/lesson/score/' + this.studentId + '/' + this.onlineClassId + '/' + this.itemId + '/' + score).then(() => {
        this.getLesson()
      })
    }
  }
}
</script>

<style scoped>
.file-container {
  height: 65vh !important;
  overflow-y: scroll !important;
}

.single-file-container {
  border-radius: 5px !important;
  border-color: black !important;
  border-style: solid !important;
  border-width: 1px !important;
}

.image-lesson {
  aspect-ratio: 1 !important;
  width: 100%;
}

.file-show-container {
  aspect-ratio: 1 !important;
  width: 100%;
}
</style>